import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { BookingFlow } from './booking/BookingFlow';

export const CTA = () => {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <section className="relative py-24 bg-red-600 overflow-hidden" data-testid="cta-section">
      <div className="absolute -right-24 top-0 h-full w-1/2 bg-neutral-950 -skew-x-12 hidden md:block"></div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="font-display italic uppercase text-4xl md:text-6xl font-extrabold text-white leading-[0.95] mb-5">
            Your Vehicle<br />Deserves Better
          </h2>
          <p className="text-white/90 text-base md:text-lg max-w-md">
            Experience the difference professional mobile detailing makes. Book your appointment today.
          </p>
        </div>
        <div className="md:text-right">
          <button
            type="button"
            onClick={() => setBookingOpen(true)}
            data-testid="cta-book-btn"
            className="group inline-flex items-center gap-2 px-10 py-5 bg-white hover:bg-neutral-100 text-neutral-950 font-display uppercase tracking-wider text-lg font-bold rounded-sm shadow-xl hover:-translate-y-0.5"
          >
            <span>Book Your Detail Now</span>
            <ArrowRight className="w-6 h-6 text-red-600 group-hover:translate-x-1 transition-transform duration-300" />
          </button>
        </div>
      </div>

      <BookingFlow open={bookingOpen} onClose={() => setBookingOpen(false)} serviceName={null} />
    </section>
  );
};
